import { useMemo } from 'react';
import { getDaysInWeek } from '../utils';

export function useWeekDays(week: string): string[] {
  return useMemo(() => getDaysInWeek(week), [week]);
}
